var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-form-item',{attrs:{"label":"问卷中文名称"}},[_c('a-input',{model:{value:(_vm.form.name),callback:function ($$v) {_vm.$set(_vm.form, "name", $$v)},expression:"form.name"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }